import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { StatutEchantillon } from './statut-echantillon.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { Animateur } from '../../commission/models/animateur.model';

export class Echantillon {
    static jsonMap = {
        id: 'id',
        datePrelevement: { key: 'datePrelevement', converter: new DateConverter() },
        codeStatut: 'codeStatut',
        codeProduit: 'codeProduit',
        libelleProduit: 'libelleProduit',
        idOperateur: 'idIntervenant',
        idControle: 'idControle',
        idStatutEchantillon: 'idStatutEchantillon',
        dateButoir: { key: 'dateButoir', converter: new DateConverter() },
        idAnimateur: 'idAgent',
        idMouvement: 'idMouvement',
        numeroDossier: 'numDossier',
        numeroOperateur: 'numeroOperateur',
        logement: 'logement',
        idSite: 'idSite',
        adresseSite: 'adresseSite',
        idCommission: 'idCommission',
        numeroCommission: 'numCommission',
        dateCommission: { key: 'dateCommission', converter: new DateConverter() }
    };

    id: number;
    datePrelevement: moment.Moment;
    codeStatut: string;
    codeProduit: string;
    libelleProduit: string;
    idOperateur: number;
    idControle: number;
    idStatutEchantillon: number;
    dateButoir: moment.Moment;
    idAnimateur: number;
    idMouvement: number;
    numeroDossier: number;
    numeroOperateur: String;
    logement: String;
    idSite: number;
    adresseSite: string;
    idCommission: number;
    numeroCommission: string;
    dateCommission: moment.Moment;

    animateur: Animateur;
    statut: StatutEchantillon;
    cvi: string;
    operateur: Operateur;

    /** Retourne vrai si la date butoir est antérieure à la date du jour */
    estPerime(): boolean {
        const now: Date = new Date();
        return this.dateButoir ? this.dateButoir.isBefore(moment([now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0])) : false;
    }
}
